import React, { useState } from 'react';
import { Plus, Minus } from 'lucide-react';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    q: '¿Es demasiado técnico para mis alumnos?',
    a: 'No. Tiene tres niveles dentro de cada tomo: básico, intermedio y avanzado. Vos elegís el nivel para cada grupo. Sin jerga innecesaria, con ejemplos reales del campo.'
  }, {
    q: '¿Necesito equipos de laboratorio para las actividades?',
    a: 'No. El Bono 1 incluye alternativas con materiales de bajo costo — disco Secchi casero, sistemas de filtración con botellas recicladas, experimentos con herramientas básicas. Diseñado para la realidad del docente técnico.'
  }, {
    q: '¿Puedo editar los materiales?',
    a: 'Sí. Todo viene en formatos editables para que lo adaptes a las normativas, el contexto de tu institución y las especies de tu región.'
  }, {
    q: '¿Funciona para cursos cortos o solo para programas anuales?',
    a: 'El Bono 4 incluye versiones de 6 meses y adaptaciones para talleres intensivos. Flexible para cualquier formato institucional.'
  }, {
    q: '¿Qué pasa si ya conozco acuicultura?',
    a: 'Este no es un curso para aprender acuicultura — es la arquitectura didáctica completa para enseñarla. Tus conocimientos técnicos más este sistema igual a tus mejores clases.'
  }, {
    q: '¿Cuándo recibo el material?',
    a: 'En menos de 5 minutos después del pago. Te llega un link de descarga directo a tu email. Sin esperas, sin trámites.'
  }, {
    q: '¿Sirve para mi país?',
    a: 'Sí. El material está desarrollado con especies y sistemas de toda la región — Tilapia, Trucha, Camarón, Pacú, Cachama. Se adapta a cualquier contexto productivo latinoamericano.'
  }, {
    q: '¿En qué moneda pago?',
    a: 'El precio está en dólares estadounidenses como referencia, pero el cobro se realiza automáticamente en la moneda de tu país al tipo de cambio del momento de la compra. Podés pagar con Mercado Pago o tu método de pago local habitual.'
  }, {
    q: '¿Para quién es el Plan Institucional de Élite?',
    a: 'Para docentes con grupos avanzados, capacitadores en empresas del sector y coordinadores de programas técnicos que quieren llevar la formación al nivel de la consultoría profesional real.'
  }, {
    q: '¿Qué pasa si no me sirve?',
    a: 'Garantía total de 7 días. Si no quedás conforme, te devolvemos el 100% de tu dinero sin preguntas ni formularios.'
  }];
  return <section className="py-9 px-4 bg-brand-cream" data-id="element-65">
      <div className="max-w-3xl mx-auto" data-id="element-66">
        <h2 className="text-2xl md:text-4xl font-display font-bold text-white text-center uppercase mb-6 leading-tight" data-id="element-67">
          ❓ Preguntas <span className="orange-text" data-id="element-68">Frecuentes</span>
        </h2>
        <div className="space-y-2.5" data-id="element-69">
          {faqs.map((faq, i) => <div key={i} className={`bg-brand-paper rounded-lg border ${openIndex === i ? 'border-brand-orange' : 'border-brand-line'} overflow-hidden transition-all`} data-id="element-70">
              <button className="w-full px-4 py-3 md:px-5 md:py-4 text-left flex justify-between items-center gap-3 focus:outline-none" onClick={() => setOpenIndex(openIndex === i ? null : i)} data-id="element-71">
                <span className={`font-display font-bold text-sm md:text-base uppercase leading-tight ${openIndex === i ? 'text-brand-orange' : 'text-white'}`} data-id="element-72">
                  {faq.q}
                </span>
                {openIndex === i ? <Minus className="w-5 h-5 text-brand-orange shrink-0" strokeWidth={3} data-id="element-73" /> : <Plus className="w-5 h-5 text-brand-mute shrink-0" strokeWidth={3} data-id="element-74" />}
              </button>
              <div className={`px-4 md:px-5 overflow-hidden transition-all duration-300 ${openIndex === i ? 'max-h-96 pb-4 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-75">
                <p className="text-sm md:text-base text-brand-ink font-medium leading-snug border-t border-brand-line pt-2.5" data-id="element-76">
                  {faq.a}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}